import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable()
export class ImageService {
  publicImageURL: string = "/images";
  publicImageURLMx: string = "/mx-be/images";
  publicImageURLBr: string = "/br-be/images";
  latamCountry = "";
  latamCountryNews = "";
  private readonly source = "HOMEPAGEAPP";

  constructor() {}

  private isValidId(id: any): boolean {
    return id != null && id !== undefined && id !== "undefined" && id !== "";
  }

  private baseUrl(country: string): string {
    return country === "latamMx"
      ? this.publicImageURLMx
      : country === "latamBr"
      ? this.publicImageURLBr
      : this.publicImageURL;
  }

  getFullImagePath(id) {
    if (!this.isValidId(id)) return null;
    return `${this.baseUrl(this.latamCountry)}/${id}/content`;
  }

  largeThumbnail(id) {
    if (!this.isValidId(id)) return null;
    return `${this.baseUrl(this.latamCountry)}/${id}/thumbnail/l?source=${
      this.source
    }`;
  }

  mediumThumbnail(id) {
    if (!this.isValidId(id)) return null;
    return `${this.baseUrl(this.latamCountry)}/${id}/thumbnail/m?source=${
      this.source
    }`;
  }

  mediumThumbnailNews(id) {
    if (!this.isValidId(id)) return null;
    return `${this.baseUrl(this.latamCountryNews)}/${id}/thumbnail/m?source=${
      this.source
    }`;
  }

  mediumLargeThumbnail(id) {
    if (!this.isValidId(id)) return null;
    return `${this.baseUrl(this.latamCountry)}/${id}/thumbnail/ml?source=${
      this.source
    }`;
  }

  smallThumbnail(id) {
    if (!this.isValidId(id)) return null;
    return `${this.baseUrl(this.latamCountry)}/${id}/thumbnail/s?source=${
      this.source
    }`;
  }

  smallThumbnailNews(id) {
    if (!this.isValidId(id)) return null;
    return `${this.baseUrl(this.latamCountryNews)}/${id}/thumbnail/s?source=${
      this.source
    }`;
  }
}
